import _sfc_main from "./DialogH5.vue2.mjs";
/* empty css               */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.visible, expression: "visible" }, { name: "tap", rawName: "v-tap", value: _setup.handleOverlayClick, expression: "handleOverlayClick" }], ref: "dialogRef", staticClass: "overlay-container", class: [_vm.modal && "overlay"], style: _setup.overlayContainerStyle }, [_c("div", { staticClass: "dialog-container" }, [_c("span", { staticClass: "dialog-title" }, [_vm._v(_vm._s(_setup.props.title))]), _c("div", { class: [_setup.hasTitle ? "dialog-content" : "dialog-content-notitle"] }, [_vm._t("default")], 2), _c("div", { staticClass: "dialog-footer" }, [_c("div", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleCancel, expression: "handleCancel" }], staticClass: "cancel-button" }, [_vm._v(" " + _vm._s(_setup.props.cancelButton) + " ")]), _c("div", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleConfirm, expression: "handleConfirm" }], staticClass: "confirm-button" }, [_vm._v(" " + _vm._s(_setup.props.confirmButton) + " ")])])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "5cb03c0e"
);
const DialogH5 = __component__.exports;
export {
  DialogH5 as default
};
